const throwOnMissing = (e: string|boolean, fieldName: string, componentName: string): void => {
    if (e === undefined || e === null) {
        throw new Error(
            `Primitive Components: ${fieldName} is not defined in ${componentName}. This is required.`,
        );
    }
};

export default throwOnMissing;
